import { Injectable } from '@angular/core';

import { ApiError } from '../model/api-error';
import { ApiException } from '../model/api-exception';
import { AlertModalComponent } from './alert-modal/alert-modal.component';
import { PopupService } from './popup.service';
import { SharedErrorLoginComponent } from './shared-templates/shared-error-login.component';

@Injectable({
  providedIn: 'root'
})
export class GenericErrorHandlerService {

  public Hanlder: (error: any) => void;

  constructor(
    private popup: PopupService,
  ) {
    this.Hanlder = this._GenericErrorHandler.bind(this);
  }

  private _GenericErrorHandler(error: any) {
    if (error instanceof ApiError) {
      if(!error.message || error.message === '') {
        error.message = 'We ran into an error with your request. Please try again, or contact us if the problem persists.';
      }
      switch (error.code) {
        case 'recaptcha':
          this.popup.Open('There was an error validating your CAPTCHA response', { Title: 'Validation Error' });
          break;
        case 401:
        case 403:
        case 'login-required':
          const popup = this.popup.Open(SharedErrorLoginComponent,
            {
              CanClose: false,
              CloseText: 'Login'
            });

          (<AlertModalComponent>popup.content).OnClose.subscribe(() => {
            window.location.href = '/user/login?refresh=1&destination=' + window.location.pathname.substring(1);
          });
          break;
        case 404:
          // Probably a REST error
          // Should be handled gracefully by the caller
          break;
        default:
          this.popup.Open(error.message, { Title: 'An error has occurred' });
      }
    } else if (error instanceof ApiException) {
      this.popup.Open(error.message, { Title: 'An API error has occurred' });
    } else {
      this.popup.Open(error.message, { Title: "We've run into an error" });
    }
  }
}
